// @flow
import type { LoginActionType } from './actions';

export type AuthStateType = {|
  token: string | null,
  externalId: string | null,
  deviceId: string | null,
|};
const initialState: AuthStateType = {
  token: null,
  externalId: null,
  deviceId: null,
};
export const authReducer = (state: AuthStateType = initialState, action: LoginActionType) => {
  switch (action.type) {
    case 'SIGN_IN_SUCCESS':
      return {
        ...state,
        token: action.payload.token,
      };
    case 'SET_DEVICE_ID':
      return {
        ...state,
        deviceId: action.payload.deviceId,
      };
    default:
      return state;
  }
};
